import styled from 'styled-components';

export const SocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  animation: fadeInUp 0.6s ease forwards;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 3rem;
  }
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;
  max-width: 800px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ContactCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  padding: 1.5rem 1.15rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 18px;
  box-shadow: 0 10px 14px rgba(107, 79, 62, 0.14);
  transition: all ${({ theme }) => theme.transitions.spring};
  text-align: center;
  min-height: 188px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 20px rgba(107, 79, 62, 0.16);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2.5rem 2rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-height: 168px;
  }
`;

export const CardIcon = styled.div<{ $color: string }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ $color }) => $color};
  box-shadow: 0 6px 20px ${({ $color }) => $color}40;
`;

export const CardTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.05rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryDark};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.15rem;
  }
`;

export const CardHandle = styled.span`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.textLight};
  line-height: 1.45;
`;

export const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem 1.25rem;
  background: ${({ theme }) => theme.colors.primaryDark};
  border-radius: 18px;
  width: 100%;
  max-width: 800px;
  text-align: center;
  box-shadow: 0 12px 16px rgba(107, 79, 62, 0.16);

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 2.5rem 3rem;
  }
`;

export const CTAText = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.5rem;
  }
`;

export const CTASubtext = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.78);
  margin-bottom: 0.5rem;
  line-height: 1.45;
`;

export const WhatsAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.9rem 2.5rem;
  background: #25d366;
  color: white;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  font-weight: 600;
  font-size: 1rem;
  transition: all ${({ theme }) => theme.transitions.spring};
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.35);

  &:hover {
    background: #1fb855;
    transform: translateY(-3px);
    box-shadow: 0 8px 28px rgba(37, 211, 102, 0.45);
  }

  svg {
    font-size: 1.25rem;
  }
`;

